// Badge
// =====

import DOM from '../Library/DOM';

const CLASS_HIDDEN = 'visually-hidden';

class Badge {
    constructor(badge) {
        this.badge = DOM.getElement(badge);
        const nextElement = this.badge.nextElementSibling;
        if (nextElement && nextElement.classList.contains(CLASS_HIDDEN)) {
            this.label = nextElement;
        } else {
            this.label = DOM.createElement(CLASS_HIDDEN, null, 'span');
            this.set(badge.textContent);
            this.badge.after(this.label);
        }
    }

    set(value) {
        this.badge.classList.toggle('show', value || false);
        this.badge.textContent = value || '';
        if (value) {
            this.label.textContent = this.badge.dataset.badgeLabel.replace('$', value);
        } else {
            this.label.textContent = this.badge.dataset.badgeEmpty;
        }
    }
}

export default Badge;
